// Mirrors backend/app.py:ROUTE_META (lines 16-47).
// Keep both in sync when adding or changing routes.

export interface RouteMeta {
  title: string
  description: string
  image: string
}

export const ROUTE_META: Record<string, RouteMeta> = {
  '/': {
    title: 'AI Services That Work for You',
    description:
      'AI services that work for you. Build products faster, adopt AI securely, and train your teams effectively.',
    image: '/images/og-default.jpg',
  },
  '/product-building': {
    title: 'Product Building with AI',
    description:
      'We build production-ready AI products from UX insight to deployment, with absolute data privacy and practical workflows.',
    image: '/images/og-default.jpg',
  },
  '/consulting': {
    title: 'AI Consulting: Privacy & Open Source',
    description:
      'Expert AI consulting to help you adopt AI securely and build products that scale.',
    image: '/images/og-default.jpg',
  },
  '/training': {
    title: 'AI Training for Teams',
    description:
      'Hands-on, role-specific AI training so your teams can use new workflows the very next day.',
    image: '/images/og-default.jpg',
  },
  '/contact': {
    title: 'Contact Us',
    description:
      'Get in touch to discuss how we can help you build, adopt, and train with AI.',
    image: '/images/og-default.jpg',
  },
  '/blog': {
    title: 'Insights & Field Notes',
    description:
      'Thoughts on building production-ready AI, maintaining data privacy, and training teams for the future.',
    image: '/images/og-default.jpg',
  },
  '/three-doors': {
    title: 'The Three Doors Checklist — Is Your SME Stuck?',
    description:
      '85.5% of Singapore SMEs have not adopted AI. The gap is not awareness, it is access. Find out which door is blocking you.',
    image: '/images/og-default.jpg',
  },
}
